export default __webpack_public_path__ + "static/media/school1.ac848d65.png";